import React from "react";
import PropTypes from "prop-types";
import { classNames } from "../../utils";
import { useEffect, useState } from "react";

export default function Badge({ active }) {
  return (
    <div className={classNames("Badge", { active })}>
      <BadgeActive />
      {/* <span className="Badge__text">
        { active ? 'Market open' : 'Market Close' }
      </span> */}
    </div>
  );
}

export function BadgeActive() {
  const [controlBadCirle, setControlBadCirle] = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      setControlBadCirle(prev => !prev);
    }, 1000);
    return () => {
      if (timer) clearInterval(timer);
    };
  }, []);


  return <span className={classNames("Badge__circle-active", { active: controlBadCirle })} />;
}

Badge.propTypes = {
  active: PropTypes.bool,
};
